import React , { useState , useEffect , useContext } from "react";
import { Link } from "react-router-dom";
import box1 from '../assets/img/banner/1.png';
import box2 from '../assets/img/banner/2.png';
import box3 from '../assets/img/banner/3.png';
import box4 from '../assets/img/banner/4.png';
import  { WebAssetsContext }  from "../App";
const  Dashboard = (props) => {
const WebAssets = useContext(WebAssetsContext);
const api = WebAssets.apiURL;
const [dashboarddata, setdashboarddata] = useState(null);
const fetchData = () => {
  fetch(api+"dashboard")
    .then(res => res.json())
    .then((result) => {
        if(result.status == true)
        {
          setdashboarddata(result.response);
        }
      }
    )
  }

  useEffect(() => {
    fetchData();

},[])
  return (
    <>
      {dashboarddata != null ? 
        <div>
          <div className="row ">
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div className="card">
                <div className="card-statistic-4">
                  <div className="align-items-center justify-content-between">
                    <div className="row ">
                      {dashboarddata != null ? 
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                        <div className="card-content">
                          <h5 className="font-15">Customers</h5>
                          <h2 className="mb-3 font-18">{dashboarddata.activeusers}</h2>
                          <p className="mb-0"><span className="col-green">Active</span></p>
                        </div>
                      </div>
                      : ''}

                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                        <div className="banner-img">
                          <img src={box1} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div className="card">
                <div className="card-statistic-4">
                  <div className="align-items-center justify-content-between">
                    <div className="row ">
                    {dashboarddata != null ? 
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                        <div className="card-content">
                          <h5 className="font-15"> Customers</h5>
                          <h2 className="mb-3 font-18">{dashboarddata.inactiveusers}</h2>
                          <p className="mb-0"><span className="col-red">In-Active</span></p>
                        </div>
                      </div>
                      : ''}
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                        <div className="banner-img">
                          <img src={box2} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div className="card">
                <div className="card-statistic-4">
                  <div className="align-items-center justify-content-between">
                    <div className="row ">
                      {dashboarddata != null ? 
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                        <div className="card-content">
                          <h5 className="font-15">Products</h5>
                          <h2 className="mb-3 font-18">{dashboarddata.products}</h2>
                          <p className="mb-0"><span className="col-green">Total products</span>
                            </p>
                        </div>
                      </div>
                      : ''}
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                        <div className="banner-img">
                          <img src={box3} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div className="card">
                <div className="card-statistic-4">
                  <div className="align-items-center justify-content-between">
                    <div className="row ">
                    {dashboarddata != null ? 
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                        <div className="card-content">
                          <h5 className="font-15">Revenue</h5>
                          <h2 className="mb-3 font-18">{props.currencySymbol()}{dashboarddata.total_order_amt ? dashboarddata.total_order_amt : 0.0}</h2>
                          <p className="mb-0"><span className="col-green">Total Revenue</span></p>
                        </div>
                      </div>
                      : ''}
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                        <div className="banner-img">
                          <img src={box4} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
          <div className="col-md-6 col-lg-12 col-xl-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="">Lasted Register Customer </h4>
                    <Link className="btn btn-primary btn-sm" to="/admin/users">View All</Link>
                  </div>
                  <div className="card-body pt-0">
                    <div className="table-responsive customtble">
                      <table className="table table-hover mb-0">
                        <thead>
                          <tr>
                          <th>NAME</th>
                          <th>EMAIL</th>
                        
                          <th width={'150px'} className="text-right">STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                        { dashboarddata.lasted_users != '' ?
                          dashboarddata.lasted_users.map((user , i)  => ( 
                          <tr key={i}>
                            <td>{user.name}</td>
                            <td>{user.email} </td>
                            
                            <td className="text-right">

                            { user.status == '1' ? <div className="badge badge-success">Active</div> : <div className="badge badge-danger">In-Active</div>}
                            </td>
                            
                            
                          </tr>
                          )) : '' }

                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-12 col-xl-6">
                <div className="card">
                  <div className="card-header">
                    <h4>Quick Buy Commodity Product</h4>
                    <Link className="btn btn-primary btn-sm" to="/admin/products">View All</Link>
                  </div>
                  <div className="card-body pt-0">
                    <div className="table-responsive customtble">
                      <table className="table table-hover mb-0">
                        <thead>
                          <tr>
                          <th>PRODUCT NAME</th>
                          <th>PRICE</th>
                          <th className="text-right">STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                        { dashboarddata.quick_buy_products != '' ?
                          dashboarddata.quick_buy_products.map((product , i)  => ( 
                          <tr key={i}>
                            <td> {product.name.toUpperCase()}</td>
                            <td>{props.currencySymbol()}{product.price} </td>
                            <td className="text-right">

                            { product.status == '1' ? <div className="badge badge-success">Active</div> : <div className="badge badge-danger">In-Active</div>}
                            </td>
                            
                            
                          </tr>
                          )) : '' }

                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
          </div>
      </div>
      : '' }
                
    </>

  );
}

export default Dashboard;
